module.exports = __webpack_public_path__ + "static/media/ep_d-arrow-right.988ad52c.svg";